(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["smilab-cart-subscription"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('smilab-cart-upgrade')) {
  customElements.define('smilab-cart-upgrade', class extends HTMLElement {
    connectedCallback() {
      if(this.initialized) return;
      this.initialized = true;
      this.addEventListener('change', e => e.stopPropagation());
      this.querySelector('button').addEventListener('click', () => this.upgrade());
    }
    async upgrade() {
      if(window.smilabCartUpgradeBusy) return;
      window.smilabCartUpgradeBusy = true;
      const button=this.querySelector('button'), select=this.querySelector('select'), status=this.querySelector('[role=status]');
      const plan=Number(select.value);
      if(!plan){window.smilabCartUpgradeBusy=false;return;}
      const lock=Array.from(document.querySelectorAll('smilab-cart-upgrade button,smilab-cart-upgrade select,button[name="checkout"],input[name="updates[]"]'));
      const disabled=lock.map(el=>el.disabled);
      lock.forEach(el=>el.disabled=true);
      button.setAttribute('aria-busy','true');
      status.hidden=true;
      const base=window.Shopify?.routes?.root || '/';
      let changed=false;
      try {
        const cartResponse=await fetch(base+'cart.js',{headers:{Accept:'application/json'}});
        if(!cartResponse.ok) throw new Error(this.dataset.error);
        const cart=await cartResponse.json();
        const lineIndex=cart.items.findIndex(item=>item.key===this.dataset.key && String(item.variant_id)===this.dataset.variant && !item.selling_plan_allocation);
        if(lineIndex<0) throw new Error(this.dataset.error);
        if(typeof window.__markInternalCartCall==='function') window.__markInternalCartCall();
        const response=await fetch(base+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line:lineIndex+1,quantity:cart.items[lineIndex].quantity,selling_plan:plan,sections:['cart-drawer','cart-icon-bubble','main-cart-items','main-cart-footer'],sections_url:location.pathname})});
        const result=await response.json();
        if(!response.ok || result.errors || result.status) throw new Error(typeof result.description==='string' ? result.description : this.dataset.error);
        changed=true;
        status.textContent=this.dataset.success;status.hidden=false;
        const replacements=[['cart-drawer','#CartDrawer'],['cart-icon-bubble','#cart-icon-bubble'],['main-cart-items','#main-cart-items'],['main-cart-footer','#main-cart-footer']];
        let refreshed=false;
        for(const [section,selector] of replacements){
          const html=result.sections?.[section];
          const target=document.querySelector(selector);
          if(!html || !target) continue;
          const source=new DOMParser().parseFromString(html,'text/html').querySelector(selector);
          if(source){target.innerHTML=source.innerHTML;refreshed=true;}
        }
        if(!refreshed) location.reload();
        if(typeof publish==='function' && typeof PUB_SUB_EVENTS!=='undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'smilab-upgrade',cartData:result});
      } catch(error) {
        if(changed) location.reload();
        else {status.textContent=error.message || this.dataset.error;status.hidden=false;}
      } finally {
        lock.forEach((el,i)=>el.disabled=disabled[i]);
        button.removeAttribute('aria-busy');
        window.smilabCartUpgradeBusy=false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["smilab-purchase-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('smilab-purchase-options')) {
  customElements.define('smilab-purchase-options', class extends HTMLElement {
    connectedCallback() {
      if(this.initialized) return;
      this.initialized = true;
      this.variants = JSON.parse(this.querySelector('[data-sm-variants]').textContent);
      this.form = this.closest('form');
      this.root = this.closest('[data-sp-buy]');
      this.frequency = this.querySelector('[data-sm-frequency]');
      this.addEventListener('change', () => this.update());
      this.update();
    }
    getPurchaseData() {
      const color = this.querySelector('[name^="sm-color-"]:checked');
      const variant = this.variants.find(v => String(v.id) === (color?.value || this.form.elements.id.value));
      if(!variant?.available) throw new Error(this.dataset.unavailable);
      const data = new FormData(this.form);
      data.set('id', variant.id);
      // Seal can inject its own hidden field. Only our visible selection determines the order.
      data.delete('selling_plan');
      if(this.querySelector('[value="subscription"]').checked) {
        const plan = variant.plans.find(p => String(p.id) === this.frequency.value);
        if(!plan) throw new Error(this.dataset.unavailable);
        data.set('selling_plan', plan.id);
      }
      return data;
    }
    update() {
      const color = this.querySelector('[name^="sm-color-"]:checked');
      const variant = this.variants.find(v => String(v.id) === (color?.value || this.form.elements.id.value));
      if(!variant) return;
      this.form.elements.id.value = variant.id;
      const previous = this.frequency.value;
      this.frequency.replaceChildren(...variant.plans.map(p => new Option(p.label, p.id)));
      if(variant.plans.some(p => String(p.id) === previous)) this.frequency.value = previous;
      const subscriptionRadio = this.querySelector('[value="subscription"]');
      subscriptionRadio.disabled = !variant.plans.length;
      if(!variant.plans.length) this.querySelector('[value="once"]').checked = true;
      this.querySelectorAll('[data-sm-sub-content]').forEach(el => el.hidden = !variant.plans.length);
      const subscription = subscriptionRadio.checked;
      const plan = variant.plans.find(p => String(p.id) === this.frequency.value);
      this.querySelector('.sm-options__frequency').hidden = !subscription;
      this.frequency.disabled = !subscription;
      this.querySelector('[data-sm-once-price]').textContent = variant.price;
      this.querySelector('[data-sm-sub-price]').textContent = plan?.price || '';
      this.root.querySelectorAll('[data-sm-selected-price]').forEach(el => el.textContent = subscription && plan ? plan.price : variant.price);
      this.root.querySelectorAll('[data-sp-main], .sp-sticky button').forEach(b => {
        b.disabled = !variant.available;
        const label = b.querySelector('[data-sm-button-label]');
        if(label) label.textContent = variant.available ? label.dataset.available : this.dataset.unavailable;
      });
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
